import React, { useMemo } from 'react';

import { useLiveQuery } from 'dexie-react-hooks';

import db from '../../lib/db';

import { useRouteWorkspace } from '../../contexts/RouteWorkspaceContext';
import { EmojiEntity } from '../EmojiEntity';

export const CustomEmojiNodeView = ({ node }) => {
  const { workspaceId } = useRouteWorkspace();
  // remap node attributes to their respective data keys (not intuitive, but it's how tiptap works)
  const dataId = useMemo(() => node.attrs.id, [node.attrs.id]);
  const dataName = useMemo(() => node.attrs.label, [node.attrs.label]);

  // look up the emoji via Dexie — check system first, then current workspace
  const emoji = useLiveQuery(async () => {
    if (!dataId) return null;
    return (await db.emojis.get(['system', dataId])) ?? (workspaceId ? await db.emojis.get([workspaceId, dataId]) : null);
  }, [dataId, workspaceId]);

  // pass node attributes through so they're still persisted
  return (
    <span data-node-view-wrapper>
      <EmojiEntity emoji={emoji} dataId={dataId} dataName={dataName} />
    </span>
  );
};
